<template lang="pug">
  v-bottom-navigation(
    v-glass="{ alphaValue: .8, blur: 8 }"
    :value="value"
    :input-value="isActive"
    :class="!isActive ? 'elevation-0' : undefined"
    :app="isActive"
    :fixed="!isActive"
    grow
    color="primary"
    :scroll-threshold="Number.POSITIVE_INFINITY"
    :style="$theme.dark ? `background-color: black` : `background-color: white`"
    :height="56")
    v-btn(
      v-for="({ icon, name, route, size }) in bottomNavigations.filter(({ getIsDisabled }) => !$get(getIsDisabled, `value`))"
      :key="name"
      rounded
      @click="onClick({ route })")
      span(v-if="name") {{ name }}
      v-icon(
        :style="size ? `font-size: ${size}px; height: ${size}px; width: ${size}px` : undefined"
        :large="!name") {{ icon }}
</template>

<script>
import { state } from '..'
import { toRefs, watch, reactive, computed } from '@vue/composition-api'
import { VBottomNavigation, VBtn, VIcon } from 'vuetify/lib'
import router, { routeCurrent } from '@iez/core/router/'

export default {
  components: {
    VBottomNavigation, VBtn, VIcon
  },

  setup () {
    const _state = reactive({
      value: computed(
        () => state.bottomNavigations
          .findIndex(
            ({
              route: {
                path
              },
              isHiddenOnActive
            }) =>
              path === routeCurrent.path
          ) - state.bottomNavigations
            .filter(({ getIsDisabled }) => getIsDisabled?.value)
            .length
      )
    })

    const onClick = ({ route }) => {
      if (route.name !== routeCurrent.name) {
        router.push({ name: route.name })
      }
    }

    return {
      ...toRefs(_state),
      ...toRefs(state),
      onClick
    }
  }
}
</script>

<style scoped>
.v-item-group.v-bottom-navigation >>> .v-btn {
  min-width: 0 !important;
}
</style>